// The following disable directive for no-restricted-imports is intentional. We need to import it for setup.
// eslint-disable-next-line no-restricted-imports
import GlobalLimitsContainer from 'crm-legacy-global-containers/GlobalLimitsContainer';
import LimitsContainer from '../containers/LimitsContainer';
const _limitsToCheck = [
// fewer lists allowed for marketing-starter-2018
'contact-lists', 'contact-smart-lists', 'calling-minutes-per-portal'];
export const setupLimitsContainer = auth => {
  const {
    portal
  } = auth;
  const limitsMap = _limitsToCheck.reduce((acc, limit) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    acc[limit] = portal.limits[limit];
    return acc;
  }, {});
  LimitsContainer.set(limitsMap);
  GlobalLimitsContainer.setContainer(LimitsContainer);
};